import React from 'react';

import "./HeroCall.css";

const HeroCall = () => {
  return(
    <div className="hero-call-container">
      <p className="hero-call-text">We are wide-command that lift up your online sales, even from the ground up!</p>

      <button className="hero-call-button">
        <p className="hero-call-button-text">
          CALL US
        </p>
      </button>
    </div>
  )
}

export default HeroCall;